import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getInlineLoader } from "../Helpers"
import BookAccess from "../ones/BookAccess"
import JournalAccess from "../ones/JournalAccess"
import VideoAccess from "../ones/VideoAccess"
import StoryAccess from "../ones/StoryAccess"


export default function LibraryContent({ orderUuid }) {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);

  async function init() {
    setReady(false);
    await callApi('get-purchased-item-data', { orderUuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        setData(null);
        appContext.tellError(response.msg || 'Could not open purchased content');
      }
    })
    setReady(true);
  }

  function getAccessView() {
    const watermark = 'MIKAKENYATA.COM';

    if (data.itemType === 'book') {
      return <BookAccess data={data} watermark={watermark} />
    } else if (data.itemType === 'journal') {
      return <JournalAccess data={data} watermark={watermark} />
    } else if (data.itemType === 'video') {
      return <VideoAccess data={data} watermark={watermark} />
    } else if (data.itemType === 'story') {
      return <StoryAccess data={data} watermark={watermark} />
    }

    return <div className="marketplace-empty-state">This content type is not supported.</div>
  }

  useEffect(() => {
    init();
  }, [orderUuid])

  return (
    <div className="container marketplace-page-container library-viewer-container">
      {
        ready && data ?
          <>
            <div className="library-viewer-heading">
              <span className="marketplace-eyebrow text-primary">{data.itemType}</span>
              <h6>{data.item.title}</h6>
              <p>This content is available through your Mika Kenyata library access.</p>
            </div>

            <div className="card library-content-description">
              <div className="card-body">
                <div
                  className="marketplace-rich-content"
                  dangerouslySetInnerHTML={{ __html: data.item.description }}
                >
                </div>
              </div>
            </div>
            {getAccessView()}
          </>
          : ready ?
            <div className="marketplace-empty-state">Purchased content was not found.</div>
            :
            <div className="mSupportLoading">{getInlineLoader()}</div>
      }
    </div>
  )
}
